module.exports = __WEBPACK_EXTERNAL_MODULE_99__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"cornerstone-core","commonjs2":"cornerstone-core","amd":"cornerstone-core","root":"cornerstone"}
// module id = 99
// module chunks = 0